    const init = () => {
        const videos = document.querySelectorAll('[data-video]');

        videos.forEach(video => {
            let playBtn = video.querySelector('.thumbImg__playBtn');
            let videoElem = video.querySelector('video');
            playBtn.addEventListener('click', () => {
                videoElem.play();
                playBtn.classList.add('hidden');
            })
            videoElem.addEventListener('click', () => {
                videoElem.pause();
                playBtn.classList.remove('hidden');
            })
        })
    }


    function ready(init) {
        if (document.readyState != 'loading') {
            init();
        } else {
            document.addEventListener('DOMContentLoaded', init);
        }
    }

    ready(init);